import { baseApi } from "./baseApi"

interface MissingDomainResponse {
  backendImplemented: false
  domain: string
  message: string
}

const makeMissing = (domain: string): MissingDomainResponse => ({
  backendImplemented: false,
  domain,
  message: `${domain} API endpoints are not implemented in backend yet.`,
})

export const missingDomainApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fraudAdapter: build.query<MissingDomainResponse, void>({
      queryFn: async () => ({ data: makeMissing("fraud") }),
      providesTags: [{ type: "MissingDomain", id: "FRAUD" }],
    }),
    kycAdapter: build.query<MissingDomainResponse, void>({
      queryFn: async () => ({ data: makeMissing("kyc") }),
      providesTags: [{ type: "MissingDomain", id: "KYC" }],
    }),
    cmsAdapter: build.query<MissingDomainResponse, void>({
      queryFn: async () => ({ data: makeMissing("cms") }),
      providesTags: [{ type: "MissingDomain", id: "CMS" }],
    }),
  }),
})

export const { useFraudAdapterQuery, useKycAdapterQuery, useCmsAdapterQuery } = missingDomainApi
